export const sorterMap: {
  key?: string;
  value: string;
  label: string;
}[] = [
  { key: "asc", value: "", label: "common.ascendingOrder" },
  { key: "desc", value: "-", label: "common.descendingOrder" },
];
